import { ApplicantLayout } from '@platform-ui/application/components/index.js';
import useAuth from '@platform-ui/auth/hooks/useAuth/index.js';
import { CheckEligibility } from '@platform-ui/eligibility/pages/index.js';
import { useUserHomeRoute } from '@platform-ui/utilities/Routes.js';
import { Navigate, Route, Routes } from 'react-router-dom-v5-compat';

enum EligibilityPaths {
  ELIGIBILITY = '/eligibility',
}

export default function EligibilityRoutes(): JSX.Element {
  const { user } = useAuth();
  const home = useUserHomeRoute();
  if (user) return <Navigate to={home} />;

  return (
    <ApplicantLayout>
      <Routes>
        <Route path={EligibilityPaths.ELIGIBILITY} element={<CheckEligibility />} />
      </Routes>
    </ApplicantLayout>
  );
}
